<template>
  <div id="contenedor-main-listado-documentos-expediente">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop
      :listadoDocumentosExpedienteContrato="getListadoDocumentosExpedienteContrato"
      :soloLectura="soloLectura">
      </desktop>
    </template>
    <template v-else>
      <mobile
      :listadoDocumentosExpedienteContrato="getListadoDocumentosExpedienteContrato"
      :soloLectura="soloLectura">
      </mobile>
    </template>
  </div>
</template>

<script>
import CATALOGO_TIPOS_DOCUMENTOS from '@/graphql/querys/administracion/catalogos/tiposdocumentos/catalogoTiposDocumentos.gql';
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoDocumentosExpediente',
  props: {
    listadoDocumentosExpedienteContrato: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  apollo: {
    catalogoTiposDocumentos: {
      query: CATALOGO_TIPOS_DOCUMENTOS,
    },
  },
  data() {
    return {};
  },
  computed: {
    getCatalogoTiposDocumentos() {
      if (!this.catalogoTiposDocumentos) return [];
      return this.catalogoTiposDocumentos
        .slice()
        .sort((a, b) => a.orden - b.orden);
    },
    getDocumentosExpedienteContrato() {
      // agrego campos necesarios a los documentos del expediente.
      const documentosExpedienteContrato = this.listadoDocumentosExpedienteContrato
        .map((documento) => ({
          ...documento,
          seEstaMostrando: false,
          tieneHijos: false,
          esPadre: false,
          childrens: [],
        }));
      return documentosExpedienteContrato;
    },
    setDocumentosPadres() {
      let documentoAnterior = null;
      const documentosPadres = this.getDocumentosExpedienteContrato;
      // recorro el arreglo de documentos padres en busca de elementos padre
      for (let i = 0; i < documentosPadres.length; i += 1) {
        // Valido si el documento anterior existe.
        if (documentoAnterior) {
          // valido que el idDocumento del documento anterior sea igual
          // al idDocumento del documento actual del ciclo for.
          if (documentoAnterior.idDocumento === documentosPadres[i].idDocumento) {
            // si los idDocumento son iguales solo se asigna a documentoAnterior
            // el documento actual del ciclo for.
            documentoAnterior = documentosPadres[i];
          } else {
            // si son diferentes se asigna como padre el documento actual del ciclo for.
            documentosPadres[i].esPadre = true;
            // asigno el documento acutal como documentoAnterior.
            documentoAnterior = documentosPadres[i];
          }
        }
        // En la primer iteracion el documento anterior no existe.
        // Por ende se toma el documento como padre y se asigna a documentoAnterior
        if (!documentoAnterior) {
          documentosPadres[i].esPadre = true;
          documentoAnterior = documentosPadres[i];
        }
      }
      return documentosPadres;
    },
    getDocumentosHijos() {
      // filtro documentos que no son padre.
      return this.setDocumentosPadres.filter((documento) => !documento.esPadre);
    },
    setDocumentosHijosaPadres() {
      // asigno valor de documentos ya identificados como padres
      const documentosHijosConPadres = this.setDocumentosPadres;
      // recorro el arreglo para buscar los hijos de cada elemento
      for (let i = 0; i < documentosHijosConPadres.length; i += 1) {
        const hijos = this.getDocumentosHijos
          .filter((documentoHijo) => documentosHijosConPadres[i].idDocumento
          === documentoHijo.idDocumento);
        // si se encuentran hijos se le asignan al padre.
        if (hijos.length > 0) {
          documentosHijosConPadres[i].tieneHijos = true;
          documentosHijosConPadres[i].childrens = hijos;
        }
      }
      return documentosHijosConPadres;
    },
    getListadoDocumentosExpedienteContrato() {
      // Se obtienen los unicamente los documentos padre. estos ya contienen a los hijos.
      const todosDocumentosPadres = this.setDocumentosHijosaPadres
        .filter((documento) => documento.esPadre);
      const listadoDocumentos = [];
      this.getCatalogoTiposDocumentos.forEach((tipoDocumento) => {
        listadoDocumentos.push({
          mostrarDocumentos: false,
          tipo: tipoDocumento.descripcion,
          documentos: todosDocumentosPadres
            .filter((documentos) => documentos.documento.idTipoDocumento === tipoDocumento.id),
        });
      });
      return listadoDocumentos;
    },
  },
};
</script>

<style lang="scss">
</style>
